import script from "./SkillLicenseConfirmView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkillLicenseConfirmView.vue?vue&type=script&lang=ts&setup=true"

import "./SkillLicenseConfirmView.vue?vue&type=style&index=0&id=5096178b&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5096178b"]])

export default __exports__